import React, { useState } from "react";
import { submitForm } from "../../services/formService";

const PrintJobForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    location: "",
    printOption: "",
    description: "",
    lead_status: "New Lead",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Send as JSON instead of FormData()
    const result = await submitForm("print", formData);
    alert(result.message);

    if (result.success) {
      setFormData({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        location: "",
        printOption: "",
        description: "",
        lead_status: "New Lead",
      });
    }
  };

  return (
    <form className="space-y-4" onSubmit={handleSubmit}>
      {/* Personal Information Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input
          type="text"
          name="firstName"
          placeholder="First Name *"
          value={formData.firstName}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary"
          required
        />
        <input
          type="text"
          name="lastName"
          placeholder="Last Name *"
          value={formData.lastName}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary"
          required
        />
      </div>

      {/* Contact Information Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input
          type="tel"
          name="phone"
          placeholder="Phone Number *"
          value={formData.phone}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary"
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email Address *"
          value={formData.email}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary"
          required
        />
      </div>

      <input
        type="text"
        name="location"
        placeholder="City, State, or Zip Code *"
        value={formData.location}
        onChange={handleChange}
        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary"
        required
      />

      {/* Print Options Dropdown */}
      <select
        name="printOption"
        value={formData.printOption}
        onChange={handleChange}
        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary"
        required
      >
        <option value="">Select Print Option *</option>
        <option value="basic-print">Basic Print - $22 / sqft</option>
        <option value="white-underlay">White Underlay - $25 / sqft</option>
        <option value="graphic-design">Graphic Design - $99 / hr</option>
      </select>

      {/* Design Description */}
      <textarea
        name="description"
        placeholder="Describe your design..."
        value={formData.description}
        onChange={handleChange}
        maxLength={180}
        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary h-24"
      ></textarea>

      {/* Submit Button */}
      <button
        type="submit"
        className="w-full bg-primary text-white py-2 rounded shadow transition-transform duration-300 ease-in-out hover:font-bold"
      >
        Request Print Job
      </button>
    </form>
  );
};

export default PrintJobForm;
